export default {
  id: "pt",
  wellcome: {
    our_mission: "Nossa missão",
    our_vission: "Nossa visão",
    our_values: "Nossos valores",
    link: "https://adventisthealth.com.br/sobre-adventist-health/",
    more_information: "Mais informações",
    vission:
      "Ser uma rede de saúde reconhecida pela excelência na assistência médico-hospitalar, prevenção e promoção de um estilo de vida saudável, integrando fé e ciência",
    mission:
      "Servir, curar e salvar, promovendo a saúde física, mental, social e espiritual, seguindo o exemplo de cristo",
    values: [
      "Amor a Deus e ao Próximo",
      "Respeito aos Princípios Bíblicos",
      "Integridade, Ética e Transparência",
      " Excelência em Servir",
      "Acolhimento, Cuidado e Compaixão",
      "Competência Técnica com Criatividade e Inovação",
      "Sustentabilidade Financeira, Social e Ambiental",
    ],
    slogan: "Servir, Curar e Salvar",
    sloganLarge: ["Acredita na vida"],
  },
  login: {
    user: "Usuário",
    userPlaceholder: "Meu usuário",
    password: "Senha",
    passwordPlaceholder: "Minha senha",
    button: "Entrar",
    quest: "Você esqueceu sua senha?",
    forgotMessage: "Entre em contato com Adventist Health",
    logoAdv: "",
    logoRed: "",
    logoBall: "../assets/logo_groups.gif",
    exit: "Sair",
    error: {
      server_undefined: "Não foi possível contatar o servidor.",
      server_error: "Temos um problema ao validar suas credenciais",
      password: "Credenciais inválidas",
    },
  },
  loading: {
    text: "Procurando informações",
  },

  common: {
    inherited:"Herdado",
    actions:"Ações",
    configurationSystem: "Carregando dados... por favor, aguarde.",
    customized: "Personalizado", 
    save: "Salvar",
    saving: "Salvando",
    loading: "Carregando",
    name: "Nome",
    description: "Descrição",
    error: "Erro",
    type: "Tipo",
    user: "Usuário",
    option: "Opção",
    options: "Opções",
    option_short: "Opç",
    leadership: "Liderança",
    kpi: "Indicador",
    kpis: "Indicador | Indicadores",
    company: "Empresa",
    plan: "Planejamento",
    view_complete_report_plan: "Ver Relatório Completo",
    no_report_found_plan: "Nenhum relatório encontrado ou disponível para este planejamento",
    verify_status_plan: "Verificar Status Clone",
    execute_phase_2_plan: "Executar fase 2",
    sector: "Setor",
    sectors: "setores",
    sectors_selected: "setor(s) selecionado(s)",
    sector_s: "um ou mais setores.",
    period: "Período",
    state: "Estado",
    agreement: "Acordo",
    group: "Perspectiva",
    stereotype: "Estereótipo",
    acreditation: "Acreditações",
    perspective: "Perspectiva",
    init: "De",
    end: "Para",
    observation: "Observação",
    comment: "Comentário",
    code: "Código",
    new: "Novo",
    add: "Adicionar",
    edit: "Editar",
    agreements: "Acordo | Acordos",
    quality: "Qualidade",
    control_managment: "Gestão de controle",
    provider: "Fornecedor",
    client: "Cliente",
    date: "Data",
    clean: "Limpar",
    delete: "Excluir",
    defuse: "Desarmar",
    active: "Ativar",
    total: "Total",
    all: "Todos",
    report: "Relatório",
    download: "Baixar",
    measure: "medição",
    history: "Histórico de resultados",
    back: "Retornar",
    approve: "Aprovar",
    yes: "Sim",
    ok: "Ok",
    no: "Não",
    points: "Pontos",
    kpi_xs: "KPI",
    search: "Pesquisar",
    role: "Papel",
    cancel: "Cancelar",
    update: "Atualizar",
    sorter: "Ordem",
    manager: "Colaborador",
    controller: "Auditor",
    avaliador: "Assessor",
    evaluator: "Assessor",
    template: "Modelo",
    created: "Criado",
    updated: "Atualizado",
    saved: "Salvo",
    progress: "Cumprimento",
    day: "Dia",
    percentProgress: "Porcentagem alcançada",
    icon: "Ícone",
    factor: "Fator",
    color: "Cor",
    noData: "Sem dados",
    selectAll: "Selecionar tudo",
    unselectAll: "Desmarcar tudo",
    list: "Lista",
    confirm: "Confirmar",
    alert: "Alerta",
    items: "Item | Itens",
    confirm_delete: "Tem certeza de eliminar? esta opção não é reversível",
    default: "Padrão",
    view: "Visualizar",
    close: "Fechar",
    retry: "Tentar novamente",
    format_not_supported: "Formato de arquivo não suportado para visualização.",
    format_see: "Formatos suportados para visualização:",
    pdf: "PDF",
    word: "Word (.docx)",
    image: "Imagens (.jpg, .png, etc.)",
    download_any: "Você pode baixar o arquivo para vê-lo.",
    other_formats: "Para outros formatos:",
    use_download: "Use o botão de download",
    open_area: "Abrem em nova aba",
    inline: "Visualização inline",
    archive: "Arquivo",
    open_with: "Após baixar, abra com o programa apropriado",
    word_document: "Documento Word - Use as barras de rolagem para navegar",
    exit_fullscreen: "Sair tela cheia",
    enter_fullscreen: "Tela cheia",
    pdf_document: "Documento PDF - Use as barras de rolagem para navegar",
    hospital_unit: "Unidade Hospitalar",
    no_data: "Nenhum dado disponível",  
    view_mode: "Modo de visualização:",
    select: "Selecione ",
    crequired: "obrigatórios",
  },

  kpi: {
    dynamicPoints: "Avaliar este período",
    dynamicPointsInfo: "Informações de pontos dinâmicos",
    dynamicPointsDesc: "Os pontos são distribuídos dinamicamente de acordo com os indicadores avaliáveis em cada período.",
    dynamicPointsForPeriod: "Distribuição de pontos para o período atual",
    evaluableKpis: "KPIs avaliáveis",
    notScheduledThisPeriod: "Não avaliado neste período",
    evaluationMode:"Modo de avaliação",
    notScheduledThisPeriod:"KPI não disponível para avaliar neste período",
    scheduledThisPeriod:"KPI disponível para análise somente em:",
    not_applicable:"Sem Meta",
    upload_evidence: "Carregar evidências",
    upload_evidence_kpi: "Carregar Evidências por Indicador",
    upload_file: "Carregar arquivo",
    upload_see: "Veja evidências",
    upload_perspectiva: " Por Perspectiva",
    upload_name: "Nome do arquivo",
    upload_codeKpi: "Código do KPI",
    attachment_file: "Arquivos anexados",
    not_avariable: "Não disponível",
    upload_set_file: "Por favor, carregue um arquivo",
    upload_set_name: "Por favor insira um nome",
    upload_ok: "Arquivo anexado com sucesso",
    upload_ko: "Erro ao salvar arquivo",
    upload_delete_ok: "O arquivo foi excluído",
    upload_delete_ko: "Erro ao excluir arquivo",
    upload_download_ko: "Erro ao baixar o arquivo",
    upload_no_data: "Não há arquivos registrados",

    stereotypes: "Estereótipos",
    acreditations: "Acreditações",
    result_value: "Resultado Final do Indicador",
    measure: "Resultado obtido",
    write: "Insira sua análise aqui",
    measure_ko: "Não atingiu a meta",
    measure_ok: "Você atingiu a meta",
    measure_value: "Alcançado",
    analysis: "Análise",
    formula: "Fórmula",
    level: "Nível",
    kpi: "Indicador",
    goal: "Meta",
    result: "Alcançado",
    percent: "% Conformidade",
    media_percent: "Média Conformidade %",
    method: "Método",
    check: "Avaliação",
    checker: "Avaliador",
    checked: "Avaliado",
    history: "Histórico de resultados",
    history_title: "Histórico de alterações",
    commentary: "Comentário",
    measure_null: "Ainda não temos dados",
    maxLength: "Tenha cuidado para não exceder o limite de caracteres permitido.",
    selectSector: "Selecione um setor para continuar",
    configTitle: "Gestão de indicadores",
    recalculatePoints: "Recalcular pontos",
    recalculatePointsOk: "Pontos recalculados em {count} indicador(es)",
    recalculatePointsKo: "Erro ao recalcular os pontos dos indicadores",
    unit: "Unidade",
    complete_no: "Não cumprido",
    complete_yes: "Cumpriu",
    generate: "Gerar indicadores",
    result_history: "Resultado das medições dos indicadores nos períodos",
    datasheet: "Ficha técnica",
    periodicity: "Periodicidade",
    monthly: "Mensal",
    bimonthly: "Bimestral",
    quarterly: "Trimestral",
    semiannual: "Semestral",
    annual: "Anual",
    masterIdRequired: "Indicador Pai é obrigatório",
    analysis_requires_result: "O resultado obtido é obrigatório para salvar",
  },

  sector: {
    sector: "Setor",
    search: "Encontre um setor",
    form: "Dados do setor",
    children: "Setores associados",
    children_ko: "Não tem setores associados",
    users: "Usuarios relacionados",
    type: "Tipo de setor",
    select_please: "Selecione um setor",
    selectSector: "Selecione um setor para continuar",
    change: "Clique para trocar de setor",
    select: "Selecione um setor",
  },

  plan: {
    modo_view: 'Modo de visualização',
    title: 'PDCA-5W2H-OKR',
    complete: 'Não há pendências para este setor',
    doing: 'Em andamento',
    action_plan: 'Plano de ação',
    kpi: 'Indicador (Indicador KPI Geral)',
    kpi_goal: 'Meta KPI',
    kr: 'Objetivo Principal',
    kr_actual: 'Resultado Atual do indicador',
    kr_goal: 'Resultado Pretendido (Meta PDCA)',
    kr_days: 'Prazo em dias',
    kr_result: 'Resultado Final do Indicador',
    reason: 'O plano de ação pertence a qual dimensão de gestão?',
    reason_description: 'Identifique o início do problema',
    reason_other: 'Outra razão',
    plan_how_kr: 'O que será feito?',
    plan_what: 'Por que será feito?',
    plan_how: 'Como será feito?',
    result: "Resultado alcançado",
    plan_who: 'Quem fará?',
    plan_when: 'Quando será feito?',
    plan_where: 'Onde será feito?',
    plan_cost: 'Quanto vai custar?',
    val_attention: 'Atenção',
    val_how: 'Preencher "como" será feito',
    val_what: 'Preencher "o que" será feito',
    val_how_kr: 'Preencher "como" o KR será alcançado',
    val_who: 'Preencher "quem" fará',
    val_where: 'Preencher "onde" será feito',
    val_cost: 'Preencher "quanto" vai custar',
    val_result: 'Preencher o Resultado Final do Indicador para salvar',
    val_goal:'Preencher a meta do PDCA',
    val_dimension: 'Selecionar a dimensão de gestão do plano de ação',
    val_init_date: 'Preencher a data de início',
    val_final_date: 'Preencher a data final',
    plan_when_description: 'insira o número de dias que será realizado',
    review_title: 'Revisão - Gestão de Controle',
    review_revisar: 'Revisar',
    review_confirm: 'Confirmar',
    review_pending: 'Pendente de aprovação',
    review_approved: 'Aprovado',
    review_pending_approval: 'Pendente de aprovação',
    pending_finalization: 'Pendente de Finalização',
    last_measure_view: 'Consultar a última mensuração',
    last_measure_title: 'Último resultado do indicador',
    last_measure_reference: 'Referente a',
    last_measure_value: 'Resultado',
    last_measure_registered: 'Registrada em',
    last_measure_goal_reached: 'Meta alcançada',
    last_measure_goal_not_reached: 'Meta não alcançada',
    last_measure_short: 'Último resultado atualizado',
    last_measure_details: 'Ver detalhes',
    no_info: 'Não há informações para mostrar',
    no_results: 'Sem resultados',
    rules_title: 'Quais indicadores aparecem nesta tela?',
    rules_1: 'Indicadores com PDCA habilitado que não alcançaram a meta no último período avaliado.',
    rules_2: 'Entenda as sinalizações',
    rules_3: 'Pendente de Criação: o indicador necessita de um novo plano de ação (PDCA).',
    rules_4: 'Pendente de Finalização: o indicador atingiu a meta, mas ainda possui um PDCA aberto que precisa ser concluído.',
    rules_5: 'Vencido: o PDCA ultrapassou a data prevista para sua conclusão.',
    rules_6: 'Pendente de Aprovação + Não Executado: aguarda aprovação do plano pelo Gerente da Área.',
    rules_7: 'Pendente de Aprovação + Andamento: aguarda aprovação do resultado final pelo Gerente da Área.',
    rules_8: 'Meta atingida e PDCA finalizado: o indicador deixa de aparecer nesta tela.', 
    rules_9: 'Importante: atingir a meta não encerra automaticamente um PDCA. Quando houver um plano de ação aberto, ele continuará disponível nesta tela até que seja devidamente finalizado.',
    review_finished: 'Finalizado',
    pending_creation: 'Pendente de criação',
    do_init: 'Data de início',
    do_end: 'Data final',
    check_advance: 'Tipo de adiantamento',
    check_pass: 'Avaliações anteriores',
    collaboration: 'Colaboração',
    collaboration_sector: 'Setor para comunicar',
    collaboration_past: 'Comunicações passadas',
    act: 'Comentários para a área de qualidade',
    do_not: 'Não executado',
    complete_yes: 'Finalizado',
    complete_no: 'Terminou sem atingir a meta',
    progress: 'Em andamento',
    review_approved_progress: 'Aprovado - Em andamento',
    excluded: 'Excluído',
    overdue: 'Vencido',
    filterState: 'Status de progresso',
    filterReview: 'Status Aprovação e Revisão',
    filterReviewNone: 'Sem revisão',
    filterClear: 'Limpar filtro',
    filterCount: 'indicador(es)',
    filterNoResults: 'Nenhum indicador encontrado para o filtro selecionado',
    bureaucracy: 'Pessoas',
    training: 'Processos',
    impact: 'Tecnologia',
    infra: 'Infraestrutura',
    plus: 'Aumentar ',
    minus: 'Diminuir ',
    validate_how: 'Complete o "como" será alcançado',
    validate_what: 'Complete o "quê" será alcançado',
    validate_description: 'Complete o "como" será alcançado o KR',
    validate_who: 'Complete o "quem" está encarregado',
    validate_where: 'Complete o "onde" será aplicada a solução',
    validate_cost: 'Complete o "quanto" custará a solução',
    pendingCreate: 'Pendentes de criar',
    progressVencido: 'Em curso(vencido)',
    progressOnTime: 'Em curso(no prazo)',
    completed: 'Cumpridos',
    what: 'O que',
    how: 'Como ',
    who: 'Quem',
    when: 'Quando',
    where: 'Onde',
    distributionState: 'Distribuição por estado',
    kpis: 'Indicadores',
    in_progress: 'Em andamento (No prazo)',
    expired: 'Em andamento (Vencidos)',
    completed: 'Finalizados com sucesso',
    not_executed: 'Não executados',
    not_reached: 'Terminou sem atingir a meta',
    pending: 'Pendentes',
    report: 'Reporte detalhado',
    title: "PDCA",
    mes: "Mês",
    semana: "Semana",
    dia: "Dia",
    months: ['', 'jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez']
  },

  risk: {
    title: "Gestão de Risco e Experiência",
    type: "Tipo de risco devido ao não cumprimento do indicador",
    patient:
      "Risco para a experiência do paciente devido ao não cumprimento do indicador",
    impact: "Impacto do não cumprimento",
    category: "Categoria ",
    operational: "Critério operacional",
    legal: "Critérios regulatórios",
    finance: "Critérios financeiros",
  },

  ose: {
    title: "OSE",
    kpi: "Dados del indicador",
    type: "Tipo de indicador",
    class: "Clasificación OSE",
    kpiType: "Tipo de indicador",
    areaSelect: "Selecione a área",
    classification: "Classificação OSE",
    classificationSelect: "Selecione uma classificação",
    detail: "Insira um detalhe",
    error: "Preencha o formulário",
    registed: "Registrados",
    unckecked: "registro pendente",
    order: "Distribuição OSE",
    kpiCount: "Número de indicadores",
    chartTitle: "Número de indicadores por classificação OSE",
    chartSubTitle: "Indicadores por OSE",
    unassigned: "Não atribuído",
    kpiList: "Lista de indicadores",
    kpiRecord: "Indicadores registrados",
    kpiPercent: "Porcentagem de conformidade",
  },

  checklist: {
    nothing: "Não há indicadores do tipo CHECKLIST para este setor.",
    new: "Novo checklist",
    edit: "Editar checklist",
    definition: "Definição do checklist",
    save: "Salvar",
    delete: "Tem certeza que deseja excluir? Esta opção não pode ser revertida.",
    select_kpi: "Selecionar KPI",
    nothing_selected: "Nenhum KPI selecionado",
    language: "Idioma",
    configuration: "Configuração do checklist",
    table: {
      index: "N°",
      code: "Código",
      check: "Check",
      factor: "Prioridade",
    },
  },

  review: {
    result: "Resultado",
    controller: "Auditor",
    feedback: "Assessor",
    complete: "Cumpriu a meta",
    evidence: "Evidência",
    analysis: "Análise",
    kpi_sector: "INDICADORES RELACIONADOS POR SETORES",
    analysis_description: "Escreva sua análise aqui",
  },

  agreement: {
    sector: "Setor Cliente",
    desc: "Descrição do acordo",
    details: "Detalhes dos Acordos Interdepartamentais",
    goal: "Meta Alcançada (≥ 100%)",
    evidence: "Evidência",
    analysis: "Análise",
    analysisEval: "Análise do Avaliador",
    writeAnalysisEval: "Escreva sua análise como avaliador...",
    analysisController: "Escreva sua análise aqui com base nos acordos interdepartamentais...",
    resumen: "Resumo dos acordos",
    total: "Total de acordos",
    totalf: "Assinados",
    complete: "Concluídos",
    percentage: "Cumprimento",
    as_provider: "Meus Acordos com outros - Fornecedor",
    as_client: "Meus Acordos - Cliente",
    motive: "Motivo do contrato",
    time: "Prazo",
    preview: "Requisito prévio",
    my: "Meu acordo",
    sign: "Assinado em ",
    complete: "Cumpriu com o acordo",
    complete_ko: "Motivo do descumprimento",
    confirm_message: "Confirmado em {date} pelo usuário {user} ",
    confirm_title: "Confirmar acordo",
    new: "Novo acordo",
    edit: "Editar acordo",
    approve: "Aprovar acordo",
    review: "Avaliação do acordo",
    confirm_delete: "Tem certeza que deseja excluir este acordo?",
    period_out: "Período vencido",
    title: "Nossos Acordos",
    select_sector: "Selecionar um setor",
    as_client_short: "Acordos como cliente",
    as_supplier_short: "Acordos como fornecedor",
    waitSign: "Assinatura pendente",
    confirmSign: "Assinatura confirmada",
    details: "Ver detalhes",
    signedSupplier: "Assinado pelo fornecedor",
    bloqued: "Acordo bloqueado",
    progress: "Em andamento",
    noStarted: "Não iniciado",
    completed: "Concluído",
    measure: "Acompanhamento do acordo",
    noSign: "Sem assinatura",
    createNew: "Criar novo acordo",
    description: "Descrição",
    descriptionRequired: "A descrição é obrigatória",
    reason: "Motivo",
    reasonRequired: "O motivo é obrigatório",
    leadtime: "Prazo de entrega",
    leadtimeRequired: "O prazo de entrega é obrigatório",
    prerequisite: "Requisito prévio",
    prerequisiteRequired: "O requisito prévio é obrigatório",
    selectSupplier: "Selecionar fornecedor",
    selectSupplierRequired: "É necessário selecionar um fornecedor",
    clientSignatoryEnabled: "Requer assinatura do cliente?",
    clientSignatoryRequired: "A assinatura do cliente é obrigatória",
    complete_required_fields: "Por favor, preencha todos os campos obrigatórios",
    creation_error: "Erro ao criar o acordo",
    successfull: "Acordo criado com sucesso",
    save: "Salvar acordo",
    sectorSupplier: "Setor fornecedor",
    sectorClient: "Setor cliente",
    sectorNoEdit: "Não é possível editar o setor",
    clientSignatoryRequiredEnable: "Assinatura do cliente habilitada",
    loadMeasure: "Carregar medida",
    completedMeasure: "Medida concluída",
    completedPercentage: "Percentual concluído",
    nonCompliance: "Razão do descumprimento",
    describeNonCompliance: "Descreva a razão pela qual ocorreu o descumprimento",
    measureUpd: "Atualizar medida",
    measureCreate: "Criar medida",
    measureUpdatedSuccess: "Medida atualizada com sucesso",
    measureCreateSuccess: "Medida criada com sucesso",
    measureCreateError: "Erro ao criar a medida",
    loadDetails: "Carregando detalhes do acordo",
    dateSignClient: "Assinado pelo cliente em",
    dateSignSupplier: "Assinado pelo fornecedor em",
    dateSignQuality: "Assinado pela área de qualidade em",
    dateSignManager: "Assinado pelo administrador (controle) em",
    signed: "Assinar acordo",
    signedConfirm: "Confirmar assinatura",
    signedConfirmTerms:
      "Lembre-se de que a assinatura é irreversível, uma vez aprovada não pode ser desfeita!",
    qualityManager: "Gestão de Qualidade",
    signedQuality: "Assinar acordo como área de Qualidade",
    controlManager: "Detalhes do acordo - Administrador",
    client: "Cliente",
    supplier: "Fornecedor",
    quality: "Qualidade",
    manager: "Administrador",
    signedManager: "Assinar como administrador",
    enable: "Ativar acordo",
    enab: "Ativar",
    disable: "Desativar acordo",
    dis: "Desativar",
    sure: "Tem certeza que deseja",
    this: "este acordo",
  },
  integration: {
    title: "Módulo de integrações",
    configuration: "Configurações",
    converters: "Conversões",
    endpoints: "Endpoints",
    integrations: "Integrações",
    editConverter: "Editar Tabela de Conversão",
    newConverter: "Nova Tabela de Conversão",
    editEndpoint: "Editar Endpoint",
    newEndpoint: "Novo Endpoint",
    tableName: "Nome da tabela",
    patron: "Padrão",
    company: "Empresa",
    findSectors: "Setores Encontrados",
    itemsChilds: "Itens de Conversão por Setor Filho",
    updSectors: "Atualizar Setores",
    loadSectors: "Carregando setores...",
    noFoundChilds: "Não foram encontrados setores filhos para o setor pai selecionado",
    valueConverted: "Insira o valor de conversão",
    sectorId: "ID do Setor",
    sectorName: "Nome do Setor",
    sectorType: "Tipo de Setor",
    value: "Valor",
    nameRequired: "O nome é obrigatório",
    errorSector: "Erro ao carregar os setores filhos",
    completeWarning: "Por favor, preencha todos os campos obrigatórios",
    noSectorWarning: "Não há setores filhos disponíveis para esta conversão",
    noTable: "Não há tabelas de conversão configuradas",
    converterValues: "Valores de conversão",
    valueTotal: "Total de Valores",
    resumen: "Resumo",
    valuesConfig: "Valores Configurados",
    noValuesConfig: "Não há itens de conversão configurados para esta tabela",
    ConfirmDelete: "Confirmar Exclusão",
    confirmDeleteConverter: "Tem certeza de que deseja excluir esta tabela de conversão?",
    confirmDeleteWarn: "Esta ação também excluirá todos os itens associados.",
    name: "Nome",
    items: "Itens",
    actions: "Ações",
    endpointType: "Tipo de endpoint",
    typeRequired: "O tipo de endpoint é obrigatório",
    url: "URL do endpoint",
    urlRequired: "A URL do endpoint é obrigatória",
    pass: "Senha de criptografia",
    algorithm: "Algoritmo de criptografia",
    secConfig: "Configurações de Segurança",
    addSecurity: "Adicionar Segurança",
    secLayer: "Camada de Segurança",
    secType: "Tipo de Segurança",
    addParamRequired: "Não são necessários parâmetros adicionais para este tipo de segurança",
    noConfigSec: "Nenhuma configuração de segurança adicionada",
    noSecurity: "Sem segurança",
    security: "Segurança",
    new: "Nova Integração",
    noEndpoint: "Sem endpoint",
    noLabel: "Sem etiqueta",
    noIntegration: "Não foram encontradas integrações que correspondam a",
    noIntegrationConfig: "Não há integrações configuradas",
    params: "Parâmetros",
    noPatron: "Sem padrão",
    noConverters: "Sem conversões",
    paramConfig: "Parâmetros configurados",
    global: "globais",
    pers: "personalizados",
    NoparamConfig: "Não há parâmetros configurados para esta integração",
    confirmDeleteInt: "Tem certeza de que deseja excluir a integração?",
    label: "Etiqueta",
    converter: "Conversão",
    paramType: "Tipo de parâmetro",
    editInt: "Editar Integração",
    newInt: "Nova Integração",
    noEndpoints: "Não há endpoints disponíveis",
    comma: "Separado por vírgulas",
    valueConf: "Valor/Configuração",
    jsonConf: "Configuração adicional em JSON ou texto simples",
    EndpointRequired: "O endpoint é obrigatório",
    paramInt: "Parâmetros da Integração",
    addParam: "Adicionar parâmetro",
    noParamTypes: "Não há tipos de parâmetros disponíveis",
    globalHint: "Campo desabilitado para tipos globais",
    converterTable: "Tabela de Conversão",
    noConverterTables: "Não há tabelas de conversão disponíveis",
    globalType: "Tipo global",
    configParamPre: "Este tipo de parâmetro usa configuração predefinida.",
    customType: "Tipo Personalizável",
    configPatronTable: "Você pode configurar padrão e tabela de conversão para este parâmetro.",
    paramProccess: "Os parâmetros definem como os dados são processados na integração",
    dataSources: "Recursos de dados",
    code: "Código",
    newDataSource: "Nova Fonte de Dados",
    editDataSource: "Editar Fonte de Dados",
    noDataSource: "Sem fonte de dados",
    dataSource: "Fonte de Dados",
    selectEndpointFirst: "Primeiro selecione um endpoint válido",
    noDataSourcesForEndpoint: "Endpoint sem fonte de dados disponível",
    selectDataSource: "Selecione uma fonte de dados",
    param: "Parâmetro",
    updateResult: "Atualizar resultado",
    integratedResult: "Resultado Integrado",
  },

  report: {
    title: "Painéis",
    dashboard: {
      title: "Dashboard",
      group_point: "Distribuição de pontuação por perspectiva",
      stereotype_point: "Distribuição de pontuação por estereótipo",
      total_point: "Total de pontos",
      percent: "Porcentagem alcançada",
      kpi_detail: "Lista detalhada de indicadores",
      average: "Média Resultados",
      fulfillment: "Desempenho dos Indicadores por Período",
      unitHospital: "Unidade Hospitalar",
      values: "Valores",
    },
    dashboardEspecifico: {
      title: "Dashboard (Unidade)",
      distribution: "Distribuição de pontos por estereótipo",
      pointsPerKpi: "Ponto por indicador",
      obtained: "Pontos obtidos",
      totalMustBe100: "O total da distribuição não é 100. A simulação continua válida, mas os percentuais deixam de ser comparáveis com a nota oficial.",
      equalize: "Distribuir igualmente",
      useCurrent: "Usar configuração atual",
      clear: "Limpar simulação",
      simulated: "Simulado",
      advanced: "Opções avançadas: fatores por estereótipo",
      advancedHint: "Estereótipos sem configuração no cadastro assumem 100% pelo resultado medido. Ajuste aqui para simular peso de evidência e análise.",
      factorComplete: "% Meta",
      factorEvidence: "% Evidência",
      factorAnalysis: "% Análise",
    },
    ranking: {
      title: "Ranking",
      unit: "Unidade administrativa",
      typeS: "Tipos de Setores",
      Loadtype: "Carregando tipos de setores...",
      selectSector: "Por favor, selecione um setor",
      selectSectorRanking: "Por favor, selecione um setor da árvore para ver sua classificação",
      loadRank: "Carregando classificação...",
      noSectors: "Nenhum setor encontrado para os filtros selecionados",
      Sector: "Setor",
      Type: "Tipo",
      Score: "Pontuação",
      Grade: "Classificação",
      noScore: "Sem medida",
      detKpi: "Detalhes dos Indicadores: ",
      rankScale: "Escala de Classificação",
      confirm_master: 'Escolha um setor no painel lateral e clique em Gerar Ranking para visualizar a classificação.',
      stop_transaction: 'Parar transação',
      kpi_report: 'Relatório de KPI',
      unitHospital: 'Unidade Hospitalar',
      generate: 'Gerar Ranking',

    },
    history: {
      title: "Histórico",
      sectorTitle: "Pontuação do Setor",
      sectorSubtitle: "Em períodos selecionados",
      sectorPoint: "Valores alcançados",
      perspectiveTitle: "Conformidade por perspectiva",
      perspectiveSubtitle: "Em períodos selecionados",
      perspectivePoint: "Porcentagem alcançada",
    },
    accreditation: {
      title: "Credenciamento",
    },
    epr: {
      title: "ERP",
      perspectiveChart: "Distribuição por perspectiva",
      percent: "Porcentagem alcançada",
      distribution: "Distribuição por EPR",
      abstract: "Resumo",
      no_classification: "Não atribuído",
    },
    comparative: {
      title: "Comparativo",
      graph: "Gerar gráfico",
      graphTitle: "Resultados dos indicadores",
      yaxis: "Valores alcançados",
    },
  },

  config: {
    title: "Configurações",
    company: "Configuração da empresa",
    basic: "Configurações básicas",
    superadmin: "Super Administrador",
    evaluationSchedule:{
      title: "Cronogramas de Avaliação",
      existingSchedules:"Lista de cronogramas",
      selectPeriods:"Selecionar Períodos",
      schedule:"Cronogramas",
      selectedCount:"Seleção de Períodos a Avaliar",
    },
    menu: {
      user: "Usuários",
      plan: "Planejamento",
      objetive: "Tipo de objetivos",
      sectorType: "Tipo de setores",
      leadership: "Liderança",
      smtp: "SMTP",
      sectors: "Setores",
      groups: "Perspectivas",
      periods: "Períodos",
      stereotypes: "Estereótipos",
      blocks: "Fechaduras",
      integrations: "Integrações",
      template: "Modelos",
      kpi: "Indicadores",
      objetives: "Objetivos",
      ranking: "Cálculos",
      accreditations: 'Acreditações',
    },
    users: {
      title: "Gerenciamento de usuários",
      search: "Pesquisar usuário",
      newUser: "Novo usuário",
      confirmDelete: "Tem certeza de que deseja excluir o usuário da instituição?",
      create: "Criar usuário",
      import: "Importar usuário",
      userExists: "Usuário já registrado",
      personalData: "Dados pessoais",
      credentials: "Credenciais",
      addSector: "Adicionar setor",
      successfull: "Usuário criado",
      changePassword: "Alterar Senha",
      userNotFound: "Usuário não encontrado",
      userRequired: "Informe um nome de usuário",
      userHint: "Digite o nome de usuário para alterar a senha",
      passwordHint: "Mínimo 6 caracteres",
      minimumPassword: "A senha deve ter no mínimo 6 caracteres",
      passwordUpdatedSuccess: "Sua senha foi atualizada com sucesso",
      passwordUpdatedUser: "Senha atualizada para o usuário {username}",
      confirmPasswordChange: "Você está prestes a alterar a senha do usuário:\n\nUsername: {username}\nNome: {name}\n\nDeseja continuar?",
      assessorPermission: "Você não tem permissão para alterar senha de outros usuários",
      userNotAuthenticated: "Usuário não autenticado",
      errorUpdatingPassword: "Erro ao atualizar senha",
    },
    sector: {
      title: "Gestão de setores",
      delete: "Excluir setor",
      deleteMessage:
        "Excluir um setor pode afetar muito o sistema, exclua com responsabilidade.",
    },
    sectorType: {
      title: "Gestão por tipo de setor",
      kpiMark: "Etiqueta",
      level: "Nível",
      asesor: "Assessor",
      kpiLetter: "Carta representativa",
      new: "Novo tipo de setor",
    },
    period: {
      title: "Gestão do período",
      start: "Data de início",
      end: "Data de término",
      from: "Mês de",
      to: "até",
      select: "Período Selecionado",
      plural: "Períodos de Avaliação",
      perspective: "Perspectiva",
      allPerspectivesShort: "Todas as perspectivas",
      filters: "Filtros",
      listTitle: "Períodos",
      picker: {
        title: "Selecione o período",
        hint: "Com todos os setores ({count}), escolha o período a configurar. A configuração vale para todos eles.",
        label: "Período",
      },
      legend: "Legenda de perspectivas",
      configure: "Configurar",
      view: {
        focusRole: "Papel em foco",
        focusHint: "Muda só a visualização das perspectivas bloqueadas; não altera permissões.",
        showMore: "Ver as demais perspectivas bloqueadas",
      },
      summary: {
        released: "Períodos liberados",
        blocked: "Períodos bloqueados",
        partial: "Períodos parciais",
        blockedPerspectives: "Perspectivas bloqueadas",
        releasedHelp: "Todos os papéis liberados em todas as perspectivas",
        blockedHelp: "Todos os papéis bloqueados em todas as perspectivas",
        partialHelp: "Há perspectivas ou papéis liberados e outros bloqueados",
        blockedPerspectivesHelp: "Soma, nos períodos, das perspectivas bloqueadas para pelo menos um papel (Colaborador, Auditor ou Assessor)",
        undetermined: "{count} período(s) sem dados suficientes ficaram fora da contagem.",
      },
      cols: {
        period: "Período",
        blocked: "Perspectivas bloqueadas",
        actions: "Ações",
      },
      state: {
        released: "Liberado",
        blocked: "Bloqueado",
        partial: "Parcial",
        unknown: "Não determinado",
        inheritedHelp: "Herdado: nenhuma perspectiva tem regra própria; vale o padrão do setor",
        inherit: "Herdar",
        releasedF: "Liberada",
        blockedF: "Bloqueada",
        inheritedValue: "Herdada: {state}",
        noneBlocked: "Nenhuma bloqueada",
      },
      context: {
        hospital: "Hospital",
        sectorType: "Tipo de setor",
        sector: "Setor",
        sectors: "Setores",
        period: "Período",
        selectedSector: "Setor selecionado",
        allSectors: "Todos os setores ({count})",
        sectorSearchLabel: "Setor (pesquisar pelo nome)",
        searchSector: "Digite o nome do setor",
        noSectorFound: "Nenhum setor encontrado",
        month: "Mês",
        sectorsCount: "{count} setores",
      },
      drawer: {
        title: "Configuração do período",
        selected: "Período selecionado",
        perspectives: "Perspectivas",
        bulkNotice: "Exibindo o primeiro dos {count} setores como referência. Ao salvar, as alterações são aplicadas a todos eles.",
        unavailable: "Não foi possível carregar a configuração deste período. Recarregue a tela.",
        roleHint: "Defina quais perspectivas estarão bloqueadas para o papel de {role} neste período.",
        generalRule: "Regra geral do papel",
        generalRuleHelp: "Vale para as perspectivas que não têm regra própria.",
        generalCurrent: "Valor efetivo atual. Não é possível saber se vem do próprio setor ou é herdado.",
        generalChanged: "Alteração pendente: será gravada ao salvar.",
        generalWillInherit: "Ao salvar, a regra própria do setor será removida e o valor passa a ser herdado.",
        releaseAll: "Liberar todas",
        blockAll: "Bloquear todas",
        restore: "Restaurar padrão",
        summary: "{count} perspectiva(s) bloqueada(s) neste cenário",
        summaryNone: "Nenhuma perspectiva bloqueada neste cenário",
        summaryUnknown: "{count} herdada(s) dependem das regras do setor e não entram nesta contagem.",
        backToInherit: "Voltar a herdar do padrão do setor",
        unsaved: "{count} alteração(ões) não salva(s)",
        save: "Salvar alterações",
        saveFirst: "Salve as alterações antes de aplicar a outros períodos.",
        noLaterPeriods: "Não há períodos seguintes a este.",
        onlySingleSector: "Disponível apenas com um setor selecionado.",
        applyNext: "Aplicar para próximos períodos",
        applyHelp: "Copia as regras por perspectiva do papel selecionado para os períodos seguintes, depois de uma confirmação.",
        discardTitle: "Descartar alterações?",
        discardText: "Há alterações que ainda não foram salvas. Se fechar agora, elas serão perdidas.",
        discard: "Descartar",
      },
      apply: {
        title: "Aplicar para próximos períodos",
        role: "Papel",
        sectors: "Setores afetados",
        perspectives: "Regras que serão copiadas",
        months: "Períodos de destino",
        warning: "As regras por perspectiva do papel {role} nos períodos marcados serão substituídas por estas. Onde está \"Herdar\", a regra própria do destino será removida.",
      },
      msg: {
        loadError: "Não foi possível carregar os períodos.",
        retry: "Tentar novamente",
        saved: "Configuração salva.",
        applied: "Configuração aplicada em {count} período(s).",
        partialFail: "{failed} de {total} gravações falharam.",
        forbidden: "Você não tem permissão para configurar este período ou setor.",
        failed: "Verifique a conexão e tente novamente.",
      },
    },
    kpi: {
      saveFirstToManageGoals: "Salve primeiro o Indicador com uma meta padrão",
      evaluationScheduleHelp:"Escolha o Cronograma de avaliação para este Indicador",
      title: "Formulário de edição de indicadores",
      new: "Novo indicador",
      createFromTemplate: "Criar a partir do modelo",
      kpiChildren: "Indicadores relacionados",
      kpiFather: "Indicador pai",
      method: "Método",
      integrations: "Integrações",
      kpiData: "Dados indicadores",
      generalData: "informações gerais",
      pdca: "Este indicador se qualifica para PDCA",
      delete:
        "Excluir um KPI pode causar instabilidade no sistema. A eliminação também envolve a remoção de KPIs relacionados ({count}) de outros setores. Use com cautela",
      confirmDelete: "Tem certeza de que deseja excluir?",
      withoutTemplate: "Nenhum modelo",
      variableGoal: "Meta variável", 
      variableGoalHelp: "Este KPI terá metas diferentes para cada período", 
      managePeriodGoals: "Metas", 
      periodGoals: "Metas por Período", 
      noPeriodGoalsConfigured: "Não há metas configuradas para períodos específicos", 
      usingDefaultGoal: "Usando meta padrão", 
      periodsConfigured: "Períodos com metas configuradas", 
      periodGoalsActive:" Metas ativas por período ",
      messagecreatefromtemplate:"É necessário criar primeiro o KPI pai: {kpiMaster} no setor {sectorMaster} para então criar o indicador {childKpi}.",
    },
    stereotype: {
      title: "Gestão de Estereótipos",
      complete: "Porcentagem de cumprimento da meta",
      evidence: "Porcentagem por evidência",
      analysis: "Porcentagem por análise",
      delete: "A remoção pode causar instabilidade no sistema, proceda com cautela.",
      syncChildren: "Aplicar aos Setores Filhos",
    },
    option: {
      syncChildren: "Aplicar aos Setores Filhos",
    },
    accreditation: {
      title: 'Gestão de acreditações',
      delete: 'Excluir acreditação',
      deleteMessage: 'Excluir uma acreditação pode afetar muito o sistema, exclua com responsabilidade.',
      id_null: 'Primeiro salve a acreditação para gerenciar seus itens.'
    },
  },

  menu: {
    operational: "Análise Operacional",
    tactic: "Análise Tática",
    strategic: "Análise Estratégica",
    plan: "PDCA-5W2H-OKR",
    process: "Processos",
    map: "Mapa Estratégico",
    risk: "Gestão de Risco e Experiência",
    ose: "OSE",
    epr: "EPR-SCS",
    checklist: "Checks",
    advance: "Avanços",
    review: "Avaliar",
    agreement: "Acordos",
    report: "Painéis",
    config: "Configurações",
  },

  process: {
    register: "Log de processo",
    add: "Adicionar processo",
    confirmDelete: "Tem certeza de que deseja excluir?",
  },

  progress: {
    title: "Progresso da conclusão dos Indicadores",
    grade: "Resultado mensal por setor",
    no_grade: "Nenhuma avaliação",
    get_data: "Obter informações de setores relacionados",
    close_sector: "Fechar setor",
    close_sector_recursive: "Fechar este setor e todos abaixo dele",
    confirm: "Tem certeza de que deseja continuar? Esta ação não pode ser desfeita.",
  },

  evaluation: {
    title: "Avaliar indicadores",
    profile: "Perfil",
    selectSector: "Selecione um setor para continuar",
    loadKpis: "Carregando indicadores para avaliar...",
    noKpis: "Não há indicadores para avaliar neste setor",
    evaluatorAnalysis: "Análise do assesor",
    goalAchieved: "Alcançado",
    situation: "Situação",
    situationFilter: "Filtrar por situação do indicador",
    situationEvaluated: "Avaliados",
    situationPending: "Pendentes",
    situationClear: "Limpar filtro",
    situationCount: "indicador(es)",
    situationNoResults: "Nenhum indicador encontrado para a situação selecionada",
    situationBySector: "Setor já inseriu os dados",
    situationByController: "Avaliado pelo auditor",
    situationByEvaluator: "Avaliado pelo assessor",
    situationPendingSector: "Setor ainda não inseriu os dados",
    situationPendingController: "Auditor ainda não avaliou",
    situationPendingEvaluator: "Assessor ainda não avaliou",
  },

  epr: {
    title: "Estrutura, Processos e Resultados",
    kpiList: "Lista de indicadores",
    slogan: "Lema",
  },

  positions: {
    leftBar: "na barra esquerda",
    rightBar: "na barra direita",
    topMenu: "no menu superior",
    bottomMenu: "no menu inferior",
    centerPanel: "no painel central",
    sidebar: "na barra lateral",
    header: "no cabeçalho",
    footer: "no rodapé",
  },

  relatorio: {
    strategicTitle:  "Relatório Estratégico",
    templateTitle:   "Relatório por Indicador",
    sectorTitle: "Relatório por Setor",
    bySetor:         "Por Setor",
    byTemplate:      "Por Indicador",
    stereotypes:     "Estereótipos",
    selectSector:    "Selecione um ou mais setores para visualizar os indicadores",
    noData:          "Nenhum indicador encontrado.",
    noTemplates:     "Selecione ao menos um estereótipo ou nenhum modelo encontrado.",
    noKpis:          "Nenhum KPI gerado por este modelo.",
    unit:    "Unidade",
    goalReached:     "Meta alcançada",
    goalNotReached:  "Meta não alcançada",
    noResult:        "Sem resultado",
    evaluated:       "avaliados",
    hideFilters:     "Ocultar árvore e filtros",
    showFilters:     "Exibir árvore e filtros",
  },
  swot: {
    initiatives: "Iniciativas",
    linkedInitiatives: "{n} iniciativa vinculada | {n} iniciativas vinculadas",
    moreInitiatives: "+ {n} iniciativa(s)",
    clickToDetail: "Clique para ver os detalhes",
    noInitiatives: "Nenhuma iniciativa vinculada a este fator.",
    loadInitiativesError: "Erro ao carregar as iniciativas.",
    retry: "Tentar novamente",
    objective: "Objetivo estratégico",
    method: "Método",
    target: "Meta",
    result: "Resultado",
    actionPlans: "{n} plano de ação | {n} planos de ação",
    openInitiative: "Abrir",
    initiativeUpdated: "Iniciativa atualizada com sucesso!",
    strength: "Força",
    weakness: "Fraqueza",
    opportunity: "Oportunidade",
    threat: "Ameaça",
  },
};